import { getStringSchema } from 'src/compass/shared/schemas';
import * as Yup from 'yup';

export const PropertySchema = Yup.object().shape({
  closedThruDate: Yup.date().required('Date is required'),
  lrpPayrollExportCode: getStringSchema(50, 'LRP Default Payroll Export Code'),
});
